// Handler for updating right panel data (Profile, Performance, Financials) when stock is clicked
AFRAME.registerComponent('right-panel-data-handler', {
    schema: {
        ticker: { type: 'string', default: '' }
    },

    init: async function () {
        console.log('right-panel-data-handler: Initializing');
        this.apiManager = null;
        this.currentTicker = null;

        try {
            this.apiManager = await RightPanelProxyAPIManager.create();
            console.log('right-panel-data-handler: RightPanelProxyAPIManager initialized successfully');
        } catch (error) {
            console.error('right-panel-data-handler: Failed to initialize RightPanelProxyAPIManager:', error.message);
            return;
        }

        this.sceneEl = this.el.sceneEl || document.querySelector('a-scene');
        if (this.sceneEl) {
            this.sceneEl.addEventListener('stock-selected', this.onStockSelected.bind(this));
            console.log('right-panel-data-handler: Listening for stock-selected events');
        }

        if (this.data.ticker) {
            this.updateDataForTicker(this.data.ticker);
        }
    },

    update: async function (oldData) {
        if (!this.apiManager || !this.apiManager.isInitialized) {
            console.log('right-panel-data-handler: API manager not initialized, skipping update');
            return;
        }

        if (oldData.ticker !== this.data.ticker && this.data.ticker) {
            console.log(`right-panel-data-handler: Ticker changed from ${oldData.ticker} to ${this.data.ticker}`);
            await this.updateDataForTicker(this.data.ticker);
        }
    },

    onStockSelected: async function (event) {
        const stock = event.detail;
        if (!stock) {
            console.warn('right-panel-data-handler: stock-selected event has no detail');
            return;
        }

        const ticker = stock.ticker || stock.symbol || stock.tickerSymbol;
        if (!ticker) {
            console.warn('right-panel-data-handler: No ticker found in stock object', stock);
            return;
        }

        console.log(`right-panel-data-handler: Stock selected: ${ticker}`);
        await this.updateDataForTicker(ticker);
    },

    updateDataForTicker: async function (ticker) {
        if (!ticker) {
            console.warn('right-panel-data-handler: No ticker provided');
            return;
        }

        if (!this.apiManager || !this.apiManager.isInitialized) {
            console.error('right-panel-data-handler: API manager not initialized');
            return;
        }

        const previousTicker = this.currentTicker;
        this.currentTicker = ticker;

        if (ticker === previousTicker) {
            console.log(`right-panel-data-handler: Refreshing data for ${ticker}`);
        } else {
            console.log(`right-panel-data-handler: Fetching data for ${ticker}...`);
        }

        try {
            const [profileData, performanceData, financialsData] = await Promise.all([
                this.apiManager.fetchCompanyProfile(ticker),
                this.apiManager.fetchStockPerformance(ticker),
                this.apiManager.fetchFinancials(ticker)
            ]);

            if (!profileData) {
                console.warn(`right-panel-data-handler: No profile data returned for ${ticker}`);
            } else {
                console.log(`right-panel-data-handler: Received profile data for ${ticker}:`, profileData);
                this.updateProfileTab(profileData);
            }

            if (!performanceData) {
                console.warn(`right-panel-data-handler: No performance data returned for ${ticker}`);
            } else {
                console.log(`right-panel-data-handler: Received performance data for ${ticker}:`, performanceData);
                this.updatePerformanceTab(performanceData, profileData);
            }

            if (!financialsData) {
                console.warn(`right-panel-data-handler: No financials data returned for ${ticker}`);
            } else {
                console.log(`right-panel-data-handler: Received financials data for ${ticker}:`, financialsData);
                console.log(`📊 Financials data structure for ${ticker}:`, {
                    hasIncome: !!financialsData.income,
                    hasBalance: !!financialsData.balance,
                    hasCashflow: !!financialsData.cashflow,
                    incomeAnnual: financialsData.income?.annual?.length || 0,
                    incomeQuarterly: financialsData.income?.quarterly?.length || 0,
                    balanceAnnual: financialsData.balance?.annual?.length || 0,
                    balanceQuarterly: financialsData.balance?.quarterly?.length || 0,
                    cashflowAnnual: financialsData.cashflow?.annual?.length || 0,
                    cashflowQuarterly: financialsData.cashflow?.quarterly?.length || 0
                });

                console.log(`📊 Full Financials Data for ${ticker}:`, JSON.stringify(financialsData, null, 2));

                if (financialsData.income?.annual?.length > 0) {
                    console.log(`📊 Sample Income Annual Record for ${ticker}:`, financialsData.income.annual[0]);
                }
                if (financialsData.income?.quarterly?.length > 0) {
                    console.log(`📊 Sample Income Quarterly Record for ${ticker}:`, financialsData.income.quarterly[0]);
                }
                if (financialsData.balance?.annual?.length > 0) {
                    console.log(`📊 Sample Balance Annual Record for ${ticker}:`, financialsData.balance.annual[0]);
                }
                if (financialsData.balance?.quarterly?.length > 0) {
                    console.log(`📊 Sample Balance Quarterly Record for ${ticker}:`, financialsData.balance.quarterly[0]);
                }
                if (financialsData.cashflow?.annual?.length > 0) {
                    console.log(`📊 Sample Cashflow Annual Record for ${ticker}:`, financialsData.cashflow.annual[0]);
                }
                if (financialsData.cashflow?.quarterly?.length > 0) {
                    console.log(`📊 Sample Cashflow Quarterly Record for ${ticker}:`, financialsData.cashflow.quarterly[0]);
                }

                this.updateFinancialsTab(financialsData, profileData);
            }

            console.log(`right-panel-data-handler: Successfully updated data for ${ticker}`);
        } catch (error) {
            console.error(`right-panel-data-handler: Failed to update data for ${ticker}:`, error);
            this.currentTicker = previousTicker;
        }
    },

    updateProfileTab: function (profileData) {
        if (!profileData) {
            console.warn('right-panel-data-handler: No profile data to update');
            return;
        }

        console.log('right-panel-data-handler: Updating profile tab with data:', profileData);
        console.log('right-panel-data-handler: Profile data fields:', {
            companyName: profileData.companyName,
            logo: profileData.logo,
            ticker: profileData.ticker,
            description: profileData.description ? profileData.description.substring(0, 50) + '...' : 'empty',
            address: profileData.address,
            sector: profileData.sector,
            industry: profileData.industry,
            employees: profileData.employees,
            exchange: profileData.exchange,
            type: profileData.type
        });

        const profileTabs = document.querySelectorAll('[profile-tab]');

        if (profileTabs.length === 0) {
            console.warn('right-panel-data-handler: No profile-tab components found');
            const altTabs = document.querySelectorAll('.profile-tab');
            if (altTabs.length === 0) {
                console.warn('right-panel-data-handler: No profile-tab components found with alternative selector');
                return;
            }
            console.log(`right-panel-data-handler: Found ${altTabs.length} profile-tab components with alternative selector`);
        }

        profileTabs.forEach((tab, index) => {
            console.log(`right-panel-data-handler: Updating profile-tab ${index + 1}/${profileTabs.length}`);

            const sectorId = this.mapSectorToId(profileData.sector);
            const normalizedSectorName = this.normalizeSectorName(profileData.sector || '');

            const updateData = {
                companyName: profileData.companyName || '',
                companyLogo: profileData.logo || '',
                ticker: profileData.ticker || this.currentTicker || '',
                description: profileData.description || '',
                address: profileData.address || '',
                sector: normalizedSectorName || profileData.sector || '',
                industry: profileData.industry || '',
                sectorId: sectorId,
                employees: profileData.employees !== null && profileData.employees !== undefined ? profileData.employees : null,
                employeesNumber: profileData.employees
                    ? `Approximately ${this.formatNumber(profileData.employees)}`
                    : 'N/A',
                exchange: profileData.exchange || '',
                type: profileData.type || ''
            };

            console.log('right-panel-data-handler: Setting profile-tab attributes:', updateData);

            const currentData = tab.getAttribute('profile-tab') || {};
            console.log('right-panel-data-handler: Current profile-tab data:', currentData);
            const sanitizedData = {};
            Object.keys(updateData).forEach(key => {
                const value = updateData[key];
                if (value === null || value === undefined) {
                    sanitizedData[key] = (key === 'employees' || key === 'sectorId') ? null : '';
                } else {
                    sanitizedData[key] = value;
                }
            });

            console.log('right-panel-data-handler: Sanitized data:', sanitizedData);

            tab.setAttribute('profile-tab', sanitizedData);

            setTimeout(() => {
                tab.emit('profile-data-updated', sanitizedData);
                const component = tab.components['profile-tab'];
                if (component && component.update) {
                    component.update(currentData);
                }

                const updatedData = tab.getAttribute('profile-tab');
                console.log('right-panel-data-handler: Verified updated data:', updatedData);
            }, 50);

            console.log('right-panel-data-handler: Updated profile-tab', profileData.ticker || this.currentTicker);
        });
    },

    updatePerformanceTab: function (performanceData, profileData) {
        if (!performanceData) {
            console.warn('right-panel-data-handler: No performance data to update');
            return;
        }

        console.log('right-panel-data-handler: Updating performance tab with data:', performanceData);

        const performanceTabs = document.querySelectorAll('[performance-tab]');

        if (performanceTabs.length === 0) {
            console.warn('right-panel-data-handler: No performance-tab components found');
            const altTabs = document.querySelectorAll('.performance-tab');
            if (altTabs.length === 0) {
                console.warn('right-panel-data-handler: No performance-tab components found with alternative selector');
                return;
            }
            console.log(`right-panel-data-handler: Found ${altTabs.length} performance-tab components with alternative selector`);
        }

        performanceTabs.forEach((tab, index) => {
            console.log(`right-panel-data-handler: Updating performance-tab ${index + 1}/${performanceTabs.length}`);

            const getValue = (val, defaultValue = null) => {
                if (val === 0) {
                    return 0;
                }
                if (val === null || val === undefined) {
                    return defaultValue;
                }
                return val;
            };

            const getNumericValue = (val) => {
                if (val === 0) {
                    return 0;
                }
                if (val === null || val === undefined) {
                    return null;
                }
                if (typeof val === 'number' && isNaN(val)) {
                    return null;
                }
                return val;
            };
            const getPerformanceValue = (val) => {
                return getNumericValue(val);
            };
            const updateData = {
                ticker: profileData?.ticker || this.currentTicker || '',
                companyLogo: profileData?.logo || '',
                prevClose: getNumericValue(performanceData.prevClose),
                open: getNumericValue(performanceData.open),
                bid: getNumericValue(performanceData.bid),
                ask: getNumericValue(performanceData.ask),
                daysRange: performanceData.daysRange && typeof performanceData.daysRange === 'object'
                    ? {
                        low: getNumericValue(performanceData.daysRange.low),
                        high: getNumericValue(performanceData.daysRange.high)
                    }
                    : { low: null, high: null },
                range52Week: performanceData.range52Week && typeof performanceData.range52Week === 'object'
                    ? {
                        low: getNumericValue(performanceData.range52Week.low),
                        high: getNumericValue(performanceData.range52Week.high)
                    }
                    : { low: null, high: null },
                volume: getNumericValue(performanceData.volume),
                avgVolume: getNumericValue(performanceData.avgVolume),
                marketCap: getNumericValue(performanceData.marketCap),
                sharesOutstanding: getNumericValue(performanceData.sharesOutstanding),
                beta5YMonthly: getNumericValue(performanceData.beta5YMonthly),
                peRatioTTM: getNumericValue(performanceData.peRatioTTM),
                epsTTM_Diluted: getNumericValue(performanceData.epsTTM_Diluted),
                forwardPERatioNTM: getNumericValue(performanceData.forwardPERatioNTM),
                forecastEPSNQTR: getNumericValue(performanceData.forecastEPSNQTR),
                priceToSalesTTM: getNumericValue(performanceData.priceToSalesTTM),
                priceToBookMRQ: getNumericValue(performanceData.priceToBookMRQ),
                priceToFreeCashFlowTTM: getNumericValue(performanceData.priceToFreeCashFlowTTM),
                enterpriseValueToRevenueTTM: getNumericValue(performanceData.enterpriseValueToRevenueTTM),
                enterpriseValueToEBITDA: getNumericValue(performanceData.enterpriseValueToEBITDA),
                earningsDate: performanceData.earningsDate || '',
                forwardDividendAndYield: performanceData.forwardDividendAndYield && typeof performanceData.forwardDividendAndYield === 'object'
                    ? {
                        annualDividendPerShare: getNumericValue(performanceData.forwardDividendAndYield.annualDividendPerShare),
                        dividendYield: getNumericValue(performanceData.forwardDividendAndYield.dividendYield)
                    }
                    : null,
                dividendDate: performanceData.exDividendDate || performanceData.nextEarningsDate || performanceData.recentDividendDate || '',
                shortInterestRatio: getNumericValue(performanceData.shortInterestRatio),
                perfWeek: getPerformanceValue(performanceData.perfWeek),
                perfMonth: getPerformanceValue(performanceData.perfMonth),
                perf6M: getPerformanceValue(performanceData.perf6M),
                perfYTD: getPerformanceValue(performanceData.perfYTD),
                perf1Y: getPerformanceValue(performanceData.perf1Y),
                perf5Y: getPerformanceValue(performanceData.perf5Y)
            };

            console.log('right-panel-data-handler: Setting performance-tab attributes:', updateData);
            console.log('right-panel-data-handler: Performance data from API:', {
                open: performanceData.open,
                daysRange: performanceData.daysRange,
                range52Week: performanceData.range52Week,
                perfWeek: performanceData.perfWeek,
                perfMonth: performanceData.perfMonth,
                perf6M: performanceData.perf6M,
                perf1Y: performanceData.perf1Y,
                perf5Y: performanceData.perf5Y
            });
            console.log('right-panel-data-handler: updateData specific values:', {
                open: updateData.open,
                daysRange: updateData.daysRange,
                range52Week: updateData.range52Week,
                perfWeek: updateData.perfWeek,
                perfMonth: updateData.perfMonth,
                perf6M: updateData.perf6M,
                perf1Y: updateData.perf1Y,
                perf5Y: updateData.perf5Y
            });

            const currentData = tab.getAttribute('performance-tab') || {};
            console.log('right-panel-data-handler: Current performance-tab data:', currentData);

            console.log('right-panel-data-handler: About to setAttribute with data:', updateData);
            tab.setAttribute('performance-tab', updateData);

            setTimeout(() => {
                const updatedData = tab.getAttribute('performance-tab');
                console.log('right-panel-data-handler: Data after setAttribute:', updatedData);
                console.log('right-panel-data-handler: Component data after setAttribute:', tab.components['performance-tab']?.data);
                const dataToEmit = updatedData || updateData;
                console.log('right-panel-data-handler: Emitting performance-data-updated with data:', dataToEmit);
                tab.emit('performance-data-updated', dataToEmit);

                const scene = this.sceneEl || document.querySelector('a-scene');
                if (scene) {
                    scene.emit('performance-data-updated', dataToEmit);
                    console.log('right-panel-data-handler: Emitted performance-data-updated on scene');
                }
            }, 100);

            console.log('right-panel-data-handler: Updated performance-tab', this.currentTicker);
        });
    },

    updateFinancialsTab: function (financialsData, profileData) {
        if (!financialsData) {
            console.warn('right-panel-data-handler: No financials data to update');
            return;
        }

        console.log('right-panel-data-handler: Updating financials tab with data:', financialsData);

        const financialsTabs = document.querySelectorAll('[financials-tab]');

        if (financialsTabs.length === 0) {
            console.warn('right-panel-data-handler: No financials-tab components found');
            const altTabs = document.querySelectorAll('.financials-tab');
            if (altTabs.length === 0) {
                console.warn('right-panel-data-handler: No financials-tab components found with alternative selector');
                return;
            }
            console.log(`right-panel-data-handler: Found ${altTabs.length} financials-tab components with alternative selector`);
        }

        financialsTabs.forEach((tab, index) => {
            console.log(`right-panel-data-handler: Updating financials-tab ${index + 1}/${financialsTabs.length}`);

            const updateData = {
                ticker: profileData?.ticker || this.currentTicker || '',
                companyLogo: profileData?.logo || '',
                financialsData: financialsData
            };

            console.log('right-panel-data-handler: Setting financials-tab attributes:', {
                ticker: updateData.ticker,
                hasFinancialsData: !!updateData.financialsData,
                hasIncome: !!updateData.financialsData?.income,
                hasBalance: !!updateData.financialsData?.balance,
                hasCashflow: !!updateData.financialsData?.cashflow
            });

            tab.setAttribute('financials-tab', updateData);

            setTimeout(() => {
                console.log('right-panel-data-handler: Emitting financials-data-updated event');
                tab.emit('financials-data-updated', updateData);
            }, 100);

            console.log('right-panel-data-handler: Updated financials-tab', this.currentTicker);
        });
    },

    normalizeSectorName: function (sectorName) {
        if (!sectorName) return '';

        const normalized = sectorName.trim();
        const sectorNormalizationMap = {
            'healthcare': 'Health Care',
            'health care': 'Health Care',
            'basic materials': 'Materials',
            'materials': 'Materials',
            'technology': 'Information Technology',
            'information technology': 'Information Technology',
            'information-technology': 'Information Technology',
            'utilities': 'Utilities',
            'energy': 'Energy',
            'financials': 'Financials',
            'real estate': 'Real Estate',
            'industrials': 'Industrials',
            'communication services': 'Communication Services',
            'consumer staples': 'Consumer Staples',
            'consumer defensive': 'Consumer Staples',
            'consumer discretionary': 'Consumer Discretionary',
            'consumer cyclical': 'Consumer Discretionary'
        };

        const lowerSector = normalized.toLowerCase();
        if (sectorNormalizationMap[lowerSector]) {
            return sectorNormalizationMap[lowerSector];
        }
        if (lowerSector.includes('healthcare') || lowerSector.includes('health care')) {
            return 'Health Care';
        }
        if (lowerSector.includes('basic materials') || (lowerSector.includes('materials') && !lowerSector.includes('information'))) {
            return 'Materials';
        }
        if (lowerSector.includes('technology') || lowerSector.includes('information')) {
            return 'Information Technology';
        }
        if (lowerSector.includes('utilities')) {
            return 'Utilities';
        }
        if (lowerSector.includes('energy')) {
            return 'Energy';
        }
        if (lowerSector.includes('financial')) {
            return 'Financials';
        }
        if (lowerSector.includes('real estate')) {
            return 'Real Estate';
        }
        if (lowerSector.includes('industrial')) {
            return 'Industrials';
        }
        if (lowerSector.includes('communication')) {
            return 'Communication Services';
        }
        if (lowerSector.includes('consumer staples') || lowerSector.includes('consumer defensive')) {
            return 'Consumer Staples';
        }
        if (lowerSector.includes('consumer discretionary') || lowerSector.includes('consumer cyclical') || lowerSector.includes('customer discretionary')) {
            return 'Consumer Discretionary';
        }

        return normalized;
    },

    mapSectorToId: function (sectorName) {
        if (!sectorName) return 1;

        const normalizedName = this.normalizeSectorName(sectorName);

        const sectorMap = {
            'Utilities': 1,
            'Energy': 2,
            'Materials': 3,
            'Financials': 4,
            'Health Care': 5,
            'Real Estate': 6,
            'Information Technology': 7,
            'Industrials': 8,
            'Communication Services': 9,
            'Consumer Staples': 10,
            'Consumer Discretionary': 11
        };

        if (sectorMap[normalizedName]) {
            return sectorMap[normalizedName];
        }
        const lowerSector = normalizedName.toLowerCase();
        for (const [key, value] of Object.entries(sectorMap)) {
            if (key.toLowerCase() === lowerSector) {
                return value;
            }
        }

        return 1;
    },

    formatNumber: function (num) {
        if (num === null || num === undefined) return '0';
        return num.toLocaleString();
    },

    remove: function () {
        if (this.sceneEl) {
            this.sceneEl.removeEventListener('stock-selected', this.onStockSelected.bind(this));
        }
    }
});

